export const CarrierConfigIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = "#5C5F62" } = props;

  return (
    <svg
      fill={fill}
      width={width}
      height={height}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 488 488"
    >
      <g>
        <g>
          <path
            d="M469.8,298.8v-52.4c0-19.9-16-35.9-35.9-35.9l-24.8-3.9l-42.5-64c-0.6-0.5-1.1-1.7-1.7-2.2c-6.6-8.8-17.1-14.9-29.3-14.9
           H255v-22.3c0-11.3-8.4-20.5-18.8-20.5H18.8C8.4,82.7,0,91.9,0,103.2v140.1v76v4.9v21c0,11.6,9.4,20.4,20.4,20.4h29.3
           c6.6,23.2,27.6,39.7,53,39.7s46.4-17.1,53-39.7h66.8h113.7c6.6,23.2,27.6,39.7,53,39.7s46.4-17.1,53-39.7h25.4
           c11.6,0,20.4-9.4,20.4-20.4v-25.9C488,308.7,479.7,299.9,469.8,298.8z M47.2,174.2c0-18.9,15.3-34.2,34.2-34.2
           s34.2,15.3,34.2,34.2s-15.3,34.2-34.2,34.2S47.2,193.1,47.2,174.2z M75.2,251.8l89.7-108.1c2.9-3.5,8.2-4,11.8-1.1l0,0
           c3.5,2.9,4,8.2,1.1,11.8L88,262.5c-2.9,3.5-8.2,4-11.8,1.1C72.6,260.7,72.2,255.4,75.2,251.8z M102.7,377.7
           c-15.5,0-27.6-12.7-27.6-27.6c0-14.9,12.7-27.6,27.6-27.6c15.5,0,27.6,12.7,27.6,27.6C130.3,365,118.2,377.7,102.7,377.7z
            M171.6,266c-18.9,0-34.2-15.3-34.2-34.2s15.3-34.2,34.2-34.2s34.2,15.3,34.2,34.2S190.5,266,171.6,266z M292.8,208.7
           c-1.4,0-2.6-1.1-2.6-2.6v-50.7c0-1.4,1.1-2.6,2.6-2.6h43.8c0.9,0,1.7,0.4,2.1,1.1l34.1,50.7c1.1,1.7-0.1,4-2.1,4h-77.9V208.7z
            M389.2,377.7c-15.5,0-27.6-12.7-27.6-27.6c0-14.9,12.7-27.6,27.6-27.6c15.5,0,27.6,12.7,27.6,27.6
           C416.8,365,404.1,377.7,389.2,377.7z"
          />
          <circle cx="81.4" cy="174.2" r="14.2" />
          <circle cx="171.6" cy="231.8" r="14.2" />
        </g>
      </g>
    </svg>
  );
};
